{
  "description": "Search terms that should not trigger AdSense requests. Case-insensitive matching.",
  "terms": ["labubu", "labub"]
}
